import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { setCustomConfigData } from "../../../../redux/actions/custom-config-data-action";
import { useDispatch } from "react-redux";
import { setCustomCompId } from "../../../../redux/actions/custom-comp-id-action";
import { setMeshData } from "../../../../redux/actions/meshdata-action";
import SwapButton from "../elements/swap-button";

const ColorSwapItem = ({
  addKit,
  colorSwap,
  alloyWheel,
  enableReset,
  OnToastMsg,
}) => {
  const [colorData, setColorData] = useState([]);
  const [alloyWheelData, setAlloyWheelData] = useState([]);
  const [colorContent, setColorContent] = useState([]);
  const dispatch = useDispatch();
  const customConfigData = useSelector((state) => state.customConfigData.data);
  const meshdata = useSelector((state) => state.meshData.data);

  useEffect(() => {
    setColorData(customConfigData?.color?.filter((i) => i.kit === true));
    setAlloyWheelData(
      customConfigData?.alloyWheel?.filter((i) => i.color === true)
    );
    meshdata?.map((item) => setColorContent(item.color));
  }, []);

  const onWeb3dColorSwap = (cId, name, price) => {
    enableReset(true);
    dispatch(setCustomCompId({ id: cId, status: "" }));
    meshdata[0].color.map((element) =>
      cId === element.id ? (element.status = true) : (element.status = false)
    );
    const updateArray = [...meshdata];
    setColorContent(updateArray[0].color);
    dispatch(setMeshData(updateArray));

    //////////////  Order details  //////////////
    const array = customConfigData?.orderDetails?.some((item) => {
      return item["uId"] === "c01";
    });

    if (array) {
      customConfigData?.orderDetails?.filter((item) => {
        if (item.uId === "c01") {
          item.ProductId = cId.toLowerCase();
          item.ProductName = "Color : " + name;
          item.Price = price;
          item.Colour = cId.toLowerCase();
        }
      });
    } else {
      customConfigData?.orderDetails.push({
        uId: "c01",
        // id: cId.toLowerCase(),
        // name: "Color : " + name,
        // color: "",
        // price: price,
        isColor: true,

        ProductName: "Color : " + name,
        ProductId: "",
        Quantity: 1,
        Colour: cId.toLowerCase(),
        Price: price,
        Type: "BTO",
      });
    }

    dispatch(setCustomConfigData(structuredClone(customConfigData)));
  };

  const onConfigColorSwap = (cId, name, price) => {
    //
    dispatch(setCustomCompId({ id: cId, status: "" }));

    customConfigData?.color?.map((element) =>
      cId === element.id ? (element.status = true) : (element.status = false)
    );
    setColorData(customConfigData?.color?.filter((i) => i.kit === true));

    //////////// Alloy Wheel //////////////
    customConfigData?.color?.filter((item) => {
      if (item.status === true) {
        customConfigData?.alloyWheel?.map((i) =>
          i?.groupIdAny.some((id) =>
            id.toLowerCase() == item.id.toLowerCase()
              ? (i.color = true)
              : (i.color = false)
          )
        );
      }
    });

    let alloyIndex = 0;
    customConfigData?.alloyWheel?.map((element) =>
      element.color === true
        ? (element.alloyIndex = ++alloyIndex)
        : (element.alloyIndex = 0)
    );

    customConfigData?.alloyWheel?.map((element) =>
      element.alloyIndex === 1
        ? (element.status = true)
        : (element.status = false)
    );

    //////////////  Order details  //////////////
    const array = customConfigData?.orderDetails?.some((item) => {
      return item["uId"] === "c01";
    });

    if (array) {
      customConfigData?.orderDetails?.filter((item) => {
        if (item.uId === "c01") {
          item.ProductId = cId.toLowerCase();
          item.ProductName = "Color : " + name;
          item.Price = parseInt(price);
          item.Colour = cId.toLowerCase();
        }
      });
    } else {
      customConfigData?.orderDetails.push({
        uId: "c01",
        isColor: true,

        ProductName: "Color : " + name,
        ProductId: "",
        Quantity: 1,
        Colour: cId.toLowerCase(),
        Price: parseInt(price),
        Type: "BTO",
      });
    }

    dispatch(setCustomConfigData(structuredClone(customConfigData)));
  };

  const onAlloyWheel = (cId, name, price) => {
    //

    dispatch(setCustomCompId({ id: cId, status: "" }));

    customConfigData?.alloyWheel?.map((element) =>
      cId === element.id ? (element.status = true) : (element.status = false)
    );
    setAlloyWheelData(
      customConfigData?.alloyWheel?.filter((i) => i.color === true)
    );

    //////////////  Order details  //////////////
    const array = customConfigData?.orderDetails?.some((item) => {
      return item["uId"] === "a01";
    });

    if (array) {
      customConfigData?.orderDetails?.filter((item) => {
        if (item.uId === "a01") {
          item.id = cId.toLowerCase();
          item.name = "Alloywheel - " + name;
          item.price = price;
        }
      });
    } else {
      customConfigData?.orderDetails.push({
        uId: "a01",
        id: cId.toLowerCase(),
        name: "Alloywheel - " + name,
        color: "",
        price: price,
      });
    }

    dispatch(setCustomConfigData(structuredClone(customConfigData)));
  };

  return (
    <SwapButton
      ToastMessage={(message) => OnToastMsg(message)}
      data={colorSwap ? (addKit ? colorData : colorContent) : alloyWheelData}
      onClick={
        colorSwap
          ? addKit
            ? onConfigColorSwap
            : onWeb3dColorSwap
          : onAlloyWheel
      }
      alloyWheel={colorSwap ? false : true}
    />
  );
};

export default ColorSwapItem;
